import { useStore } from 'react-redux'

export default function useAct() {
  const dispatch = useDispatch()
  const store = useStore()

  return {
    donation: {
      upsert(payload) {
        dispatch({ type: 'donation/upsert', payload })
      },
      save() {
        const donation = store.getState().donation
        return axios.post('/api/donations', decamelizeKeys(donation))
      }
    }
  }
}
